/**
 * One-shot service-worker sweep.
 *
 * The app intentionally runs with NO service worker (assets are hash-cached by
 * HTTP headers; the entry HTML is no-cache; updates are handled by
 * AppUpdateToast). But the old template shipped `public/mockServiceWorker.js`
 * (MSW), and any browser that ever registered it keeps that worker alive
 * FOREVER — intercepting requests and serving stale responses long after the
 * file was removed from the repo. Unregister anything found so every client
 * ends up service-worker-free.
 *
 * Remove/rework this when Web Push lands (that feature will bring its own,
 * managed service worker).
 */
export default defineNuxtPlugin(() => {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return

  navigator.serviceWorker
    .getRegistrations()
    .then(registrations => {
      for (const registration of registrations) registration.unregister()
    })
    .catch(() => { /* unsupported / blocked — nothing to clean */ })
})
